<script>
import {registFormEventDataLambdaInvoke} from '../../utils/LambdaHelper'
import {getUserSessionCookie} from '../../utils/Auth'

export default {
  methods: {
    sendInputEvent (e) {
      this.sendEvent('input')
    },
    sendFocusEvent (e) {
      this.sendEvent('focus')
    },
    sendChangeEvent (e) {
      this.sendEvent('change')
    },
    sendBlurEvent (e) {
      this.sendEvent('blur')
    },
    sendClickEvent (e) {
      this.sendEvent('click')
    },
    sendMousedownEvent (e) {
      this.sendEvent('mousedown')
    },
    sendMouseoverEvent (e) {
      this.sendEvent('mouseover')
    },
    sendMouseoutEvent (e) {
      this.sendEvent('mouseout')
    },
    sendKeydownEvent (e) {
      this.sendEvent('keydown')
    },
    sendKeyupEvent (e) {
      this.sendEvent('keyup')
    },
    isSendEventData () {
      if (!this.trackingEventDataSetting || !this.trackingName) {
        return false
      }
      return this.trackingEventDataSetting[this.trackingName] === '1'
    },
    async sendEvent (eventType) {
      try {
        if (this.isSendEventData() && eventType && getUserSessionCookie() && this.$store.getters.getSystemAuId) {
          let eventData = {
            system_auid: this.$store.getters.getSystemAuId,
            key: this.trackingName,
            event: eventType
          }
          await registFormEventDataLambdaInvoke(eventData)
        }
      } catch (e) {
        this.sendErrorEvent()
      }
    },
    async sendErrorEvent () {
      try {
        if (getUserSessionCookie()) {
          let eventData = {
            system_auid: this.$store.getters.getSystemAuId,
            key: this.trackingName,
            event: 'get_error'
          }
          await registFormEventDataLambdaInvoke(eventData)
        }
      } catch (error) {
      }
    }
  },
  computed: {
    trackingEventDataSetting () {
      return this.$store.getters.getTrackingEventDataSetting
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/mixin/FormEvent.vue